var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whole-page"},[_c('Sidebar',{staticClass:"sidebar-wrap"}),_c('div',{staticClass:"with-sidebar"},[_c('Search',{staticClass:"search",on:{"searchStatus":(status) => _vm.searching = status}}),(!_vm.searching)?_c('UsersTop'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }